import BaseView from 'components-framework/view/base.view';

export const PriceSummaryView = BaseView.extend({
    render() {
        const template = this.buildTemplate();
        this.$el.html(template);
    },
    buildTemplate() {
        const keys = this.keys;
        const priceSubscription = Odigeo.Utils.formatCurrency(this.model.getSubscriptionPrice());
        const isFreeTrial = this.model.isFreeTrial();
        const isSubscriptionAdded = this.model.isSubscriptionAdded();
        const durationDays = this.model.getSubscriptionDuration();

        keys.priceSummarySubscriptionPrice = Odigeo.Utils.replaceCmsKeyArgs(keys.priceSummarySubscriptionPrice, durationDays);
        return this.templates.main({
            keys,
            isFreeTrial,
            priceSubscription,
            isSubscriptionAdded,
        });
    },
    onChangeOffer(isMembershipAdded) {
        this.$el.find('.membershipPriceSummary').toggleClass('odf-hidden', !isMembershipAdded);
    },
});
